/**
 * Created by Angelika on 01.09.2017.
 */
import React, {Component} from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {Link} from 'react-router';
import PropTypes from 'prop-types';
import * as GenresActions from "../actions/genres";

class GenreList extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selected: ''
        };

        this.handleSelectChange = this.handleSelectChange.bind(this);
    }

    menuClick(event, genre) {
        const {genresActions, onItemClick} = this.props;
        genresActions.selectGenre(genre);
        onItemClick(genre);
    }

    handleSelectChange(event) {

        let id = event.target.value;

        this.setState({selected: id});

        const {genres} = this.props;

        let filtered = genres.filter((item) => {
            if (item.id === id) {
                return item;
            }
        });

        if (filtered.length) {
            this.menuClick(event, filtered[0]);
        }

    }

    render() {
        const {genres, itemActive, type} = this.props;
        const {selected} = this.state;
        return (
            <div>
                {type === 'list' ?
                    <ul className="sub-menu">
                        {genres.map((item, index) => (
                            <li key={index} className={item.id === itemActive ? "active" : ""}>
                                <Link to={'/channels'} onClick={e => this.menuClick(e, item)}>{item.title}</Link>
                            </li>
                        ))}
                    </ul>
                    :
                    <select name="" id="" value={selected} onChange={this.handleSelectChange}>
                        {genres.map((item, index) => (
                            <option key={index} value={item.id}>
                                {item.title}
                            </option>
                        ))}
                    </select>
                }
            </div>

        )
    }
}

GenreList.defaultProps = {
    type: 'list',
    onItemClick: () => {
        return false;
    }
};

GenreList.propTypes = {
    type: PropTypes.oneOf(['list', 'select']),
    genres: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            title: PropTypes.string
        })
    ),
    activeGenre: PropTypes.shape({
        id: PropTypes.string.isRequired,
        title: PropTypes.string
    }),
    genresActions: PropTypes.shape({
        selectGenre: PropTypes.func.isRequired
    }),
    topMenuActive: PropTypes.string,
    onItemClick: PropTypes.func
};

const mapStateToProps = state => {
    return {
        genres: state.genres.items,
        activeGenre: state.genres.activeGenre
    }
};


const mapDispatchToProps = dispatch => {
    return {
        genresActions: bindActionCreators(GenresActions, dispatch)
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GenreList);


// WEBPACK FOOTER //
// ./src/containers/GenreList.js